var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#6FCC87"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "url(#paint0_linear_9487_32034)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.354 9.41217H11.2553C10.3046 9.41217 9.52686 10.1899 9.52686 11.1406V23.2393C9.52686 24.1899 10.3046 24.9677 11.2553 24.9677H23.354C24.3046 24.9677 25.0824 24.1899 25.0824 23.2393V11.1406C25.0824 10.1899 24.3046 9.41217 23.354 9.41217ZM13.8478 21.5109C13.3725 21.5109 12.9836 21.122 12.9836 20.6467V16.3258C12.9836 15.8504 13.3725 15.4616 13.8478 15.4616C14.3232 15.4616 14.712 15.8504 14.712 16.3258V20.6467C14.712 21.122 14.3232 21.5109 13.8478 21.5109ZM17.3046 21.5109C16.8293 21.5109 16.4404 21.122 16.4404 20.6467V13.7332C16.4404 13.2578 16.8293 12.869 17.3046 12.869C17.7799 12.869 18.1688 13.2578 18.1688 13.7332V20.6467C18.1688 21.122 17.7799 21.5109 17.3046 21.5109ZM20.7614 21.5109C20.2861 21.5109 19.8972 21.122 19.8972 20.6467V18.9183C19.8972 18.443 20.2861 18.0541 20.7614 18.0541C21.2367 18.0541 21.6256 18.443 21.6256 18.9183V20.6467C21.6256 21.122 21.2367 21.5109 20.7614 21.5109Z",
    fill: "url(#paint1_linear_9487_32034)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9487_32034",
    x1: 9.98466,
    y1: 35.5833,
    x2: 41.8686,
    y2: 10.3291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9E9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDFFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9487_32034",
    x1: 25.063,
    y1: 9.50754,
    x2: 9.50745,
    y2: 23.7668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FCC87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54B06C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollIconNew);
export default __webpack_public_path__ + "static/media/PollIconNew.5fd8eb08a4bdcb2da45a5c8aae90f782.svg";
export { ForwardRef as ReactComponent };